export const MORTGAGE_FIELDS_LABELS = {
  last_name: 'Фамилия',
  first_name: 'Имя',
  middle_name: 'Отчество',
  sex: 'Пол',
  education: 'Образование',
  email: 'Email',
  phone: 'Номер телефона',
  tax_number: 'ИНН',
  dateofbirth: 'Дата рождения',
  insurance_number: 'Снилс',
  loan_payments: 'Сумма платежей по действующим кредитам',
  public_official_person: 'Являетесь ли вы публичным должностным лицом или его близким родственником',
  loan_for_fee: 'Используете ли вы заёмные средства для первоначального взноса',
  is_guarantor: 'Является ли созаёмщик поручителем',
  changed_name: 'Изменялось ФИО',
  previous_last_name: 'Фамилия до изменения',
  previous_first_name: 'Имя до изменения',
  previous_middle_name: 'Отчество до изменения',
  passport_serial: 'Серия',
  passport_number: 'Номер',
  passport_division_code: 'Код подразделения',
  passport_issuing: 'Место выдачи',
  passport_date: 'Дата выдачи',
  birth_place: 'Место рождения',
  changed_document: 'Изменялся паспорт',
  old_passport_serial: 'Серия до изменения',
  old_passport_number: 'Номер до изменения',
  old_passport_division_code: 'Код подразделения до изменения',
  old_passport_date: 'Дата выдачи паспорта до изменения',
  address: 'Адрес регистрации',
  address_status: 'Статус адреса регистрации',
  actual_address: 'Адрес проживания',
  marital_status: 'Семейное положение',
  dependents: 'Кол-во детей',
  dependents_birth_dates: 'Даты рождения детей через запятую',
  alimony: 'Сумма алиментов',
  maternity_leave: 'Отпуск по беременности и родам',
  employment_type: 'Тип занятости',
  employment_experience: 'Текущий стаж работы',
  total_experience: 'Общий стаж работы',
  employer_name: 'Название организации',
  work_tax_number: 'ИНН организации',
  employment_position: 'Должность',
  employment_position_type: 'Тип должности',
  employer_activity: 'Сфера деятельности',
  employment_income: 'Месячный доход',
  proof_employment_income: 'Подтвержденный доход',
  add_income: 'Дополнительный доход',
  add_income_type: 'Тип дополнительного дохода',
  additional_income_confirmation_document: 'Документ подтверждающий дополнительный доход',
  income_confirmation_document: 'Документ подтверждающий доход',
  nature_of_work: 'Характер работы',
  work_employees_count: 'Кол-во рабочих в организации',
  employer_foundation_date: 'Дата основания предприятия',
  employer_phone: 'Номер телефона организации',
  employer_okved: 'ОКВЭД организации',
  work_business_share: 'Доля в предприятии',
  work_address: 'Рабочий адрес',
  is_lawyer: 'Являетесь ли вы адвокатом',
  is_notary: 'Являетесь ли вы нотариусом',
  change_job: 'Планируете ли вы сменить работу в ближайшее время',
  add_employer_name: 'Название организации',
  add_employment_type: 'Тип занятости',
  add_work_tax_number: 'ИНН организации',
  add_employment_experience: 'Текущий стаж работы',
  add_employment_position: 'Должность',
  add_employment_position_type: 'Тип должности',
  add_employer_activity: 'Сфера деятельности',
  add_employment_income: 'Месячный доход',
  add_proof_employment_income: 'Подтвержденный доход',
  add_income_confirmation_document: 'Документ подтверждающий доход',
  add_nature_of_work: 'Характер работы',
  add_work_employees_count: 'Кол-во рабочих в организации',
  add_employer_foundation_date: 'Дата основания предприятия',
  add_employer_phone: 'Номер телефона',
  add_employer_okved: 'ОКВЭД организации',
  add_work_business_share: 'Доля в предприятии',
  add_work_address: 'Рабочий адрес',
  add_is_lawyer: 'Являетесь ли вы адвокатом',
  add_is_notary: 'Являетесь ли вы нотариусом',

  employer_activity_in_company: 'Сфера деятельности в компании',
  employer_legal_form: 'Организационно-правовая форма',
  employer_other_legal_form: 'Организационно-правовая форма (укажите)',

  add_employer_activity_in_company: 'Сфера деятельности в компании',
  add_employer_legal_form: 'Организационно-правовая форма',
  add_employer_other_legal_form: 'Организационно-правовая форма (укажите)',

  relative_person:
    'Являетесь ли Вы родственником лица либо работником предприятия которому ранее предоставлялся кредит в АО «КБ ДельтаКредит»?',

  is_it_mortgage_participant: 'Участвует в программе ИТ Ипотека',
  is_subsidy_kids_participant: 'Участвует в программе субсидирования',

  disabled_dependent_birth_date: 'Дата рождения ребенка-инвалида',

  usa_tax_consent:
    'Предоставляете ли Вы согласие Банку на передачу информации в налоговый орган США и (или) налоговым агентам США?',
  usa_tax_payer: 'Являетесь ли Вы налогоплательщиком США?',
  foreign_tax_resident: 'Являетесь ли Вы иностранным налоговым резидентом (за исключением РФ/США)',

  own_funds_amount: 'Собственные средства в сумме кредита',

  address_type: 'Постоянная регистрация',
  address_phone: 'Телефон по месту регистрации',
  actual_address_phone: 'Телефон по месту проживания',

  marriage_contract: 'Брачный договор',
  notarial_consent: 'Нотариальное согласие'
}
